
{
  "familyId": "REK-TAFELS-TOEPASSEN",
  "questions": [
    {
      "id": "REK-TAFELS-TOEPASSEN-001",
      "familyId": "REK-TAFELS-TOEPASSEN",
      "module": "Basisrekenen",
      "tier": 3,
      "levelCode": "M6",
      "group": 6,
      "skill": "tafels",
      "subSkill": "tafels_context",
      "questionType": "multiple_choice",
      "question": "Een bakker legt brownies op bakplaten. Elke bakplaat heeft 6 rijen met 8 brownies. Hoeveel brownies passen er op één bakplaat?",
      "options": ["48", "42", "54", "56"],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Rijen × aantal per rij",
            "content": "6 rijen van 8 brownies = 6 × 8. De tafel van 6: 6, 12, 18, 24, 30, 36, 42, 48. Het 8e getal is 48. Of denk: 6 × 8 = 48 (verdubbel 3 × 8 = 24 → 48).",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "tafels_context_rijen_bakker",
      "variantIndex": 1,
      "citoDifficulty": 0.32,
      "citoDiscrimination": 0.72,
      "feedback": {
        "explanationText": "6 rijen van 8 brownies = 6 × 8 = 48. Bij 'rijen van' vermenigvuldig je het aantal rijen met het aantal per rij. De bakker past dus 48 brownies op één bakplaat.",
        "solutionSteps": [
          "Lees: 6 rijen van 8 brownies",
          "Herken de bewerking: 6 × 8",
          "Reken uit: 6 × 8 = 48"
        ],
        "distractorExplanations": {
          "0": "Goed! 6 × 8 = 48 brownies op de bakplaat.",
          "1": "Je dacht waarschijnlijk aan 6 × 7 = 42. Maar er liggen 8 brownies per rij, niet 7. Lees het aantal per rij goed.",
          "2": "Je dacht waarschijnlijk aan 6 × 9 = 54. Maar er liggen 8 brownies per rij, niet 9. Onthoud: 6 × 8 = 48.",
          "3": "Je dacht waarschijnlijk aan 7 × 8 = 56. Maar er zijn 6 rijen, niet 7. Onthoud: 6 × 8 = 48."
        }
      }
    },
    {
      "id": "REK-TAFELS-TOEPASSEN-002",
      "familyId": "REK-TAFELS-TOEPASSEN",
      "module": "Basisrekenen",
      "tier": 3,
      "levelCode": "M6",
      "group": 6,
      "skill": "tafels",
      "subSkill": "tafels_context",
      "questionType": "multiple_choice",
      "question": "Een bloemist maakt boeketten. In elk boeket zitten 7 rozen. Ze heeft een bestelling van 9 boeketten. Hoeveel rozen heeft ze nodig?",
      "options": ["63", "56", "72", "54"],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Aantal × per stuk",
            "content": "9 boeketten van 7 rozen = 9 × 7 = 63. Truc: 9 × 7 = 10 × 7 − 7 = 70 − 7 = 63.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "tafels_context_herhaald_optellen",
      "variantIndex": 2,
      "citoDifficulty": 0.35,
      "citoDiscrimination": 0.74,
      "feedback": {
        "explanationText": "9 boeketten van 7 rozen = 9 × 7 = 63 rozen. Bij 'per stuk' vermenigvuldig je het aantal stuks met het aantal per stuk. Handig: 9 × 7 = 10 × 7 − 7 = 70 − 7 = 63.",
        "solutionSteps": [
          "Lees: 9 boeketten, 7 rozen per boeket",
          "Herken: 9 × 7",
          "Reken uit: 9 × 7 = 63 (of: 10 × 7 − 7 = 63)"
        ],
        "distractorExplanations": {
          "0": "Goed! 9 × 7 = 63 rozen in totaal.",
          "1": "Je dacht waarschijnlijk aan 8 × 7 = 56. Maar er zijn 9 boeketten, niet 8. Lees het aantal boeketten goed.",
          "2": "Je dacht waarschijnlijk aan 9 × 8 = 72. Maar er zitten 7 rozen per boeket, niet 8. Onthoud: 9 × 7 = 63.",
          "3": "Je dacht waarschijnlijk aan 9 × 6 = 54. Maar er zitten 7 rozen per boeket, niet 6. Onthoud: 9 × 7 = 63."
        }
      }
    },
    {
      "id": "REK-TAFELS-TOEPASSEN-003",
      "familyId": "REK-TAFELS-TOEPASSEN",
      "module": "Basisrekenen",
      "tier": 3,
      "levelCode": "M6",
      "group": 6,
      "skill": "tafels",
      "subSkill": "tafels_context",
      "questionType": "multiple_choice",
      "question": "Een fietsenmaker heeft 8 fietsen in de werkplaats. Elke fiets heeft 2 wielen en elke wiel heeft 9 spaken die vervangen moeten worden. Hoeveel spaken heeft de fietsenmaker in totaal nodig voor alle wielen?",
      "options": ["144", "72", "128", "162"],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Stap voor stap — twee tafels",
            "content": "Stap 1: Hoeveel wielen? 8 fietsen × 2 wielen = 16 wielen. Stap 2: Hoeveel spaken? 16 wielen × 9 spaken = 144 spaken. Truc: 16 × 9 = 16 × 10 − 16 = 160 − 16 = 144.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "tafels_context_tweestaps",
      "variantIndex": 3,
      "citoDifficulty": 0.45,
      "citoDiscrimination": 0.76,
      "feedback": {
        "explanationText": "Eerst het aantal wielen: 8 × 2 = 16 wielen. Dan het aantal spaken: 16 × 9 = 144. Truc: 16 × 9 = 16 × 10 − 16 = 160 − 16 = 144 spaken in totaal.",
        "solutionSteps": [
          "Stap 1: 8 fietsen × 2 wielen = 16 wielen",
          "Stap 2: 16 wielen × 9 spaken = ?",
          "Reken: 16 × 9 = 16 × 10 − 16 = 160 − 16 = 144"
        ],
        "distractorExplanations": {
          "0": "Goed! 8 × 2 = 16 wielen, en 16 × 9 = 144 spaken in totaal.",
          "1": "Je dacht waarschijnlijk aan 8 × 9 = 72. Maar je vergat dat elke fiets 2 wielen heeft! Eerst: 8 × 2 = 16 wielen, dan 16 × 9 = 144.",
          "2": "Je dacht waarschijnlijk aan 16 × 8 = 128. Maar elke wiel heeft 9 spaken, niet 8. 16 × 9 = 144.",
          "3": "Je dacht waarschijnlijk aan 18 × 9 = 162. Maar er zijn 16 wielen (8 × 2), niet 18. 16 × 9 = 144."
        }
      }
    },
    {
      "id": "REK-TAFELS-TOEPASSEN-004",
      "familyId": "REK-TAFELS-TOEPASSEN",
      "module": "Basisrekenen",
      "tier": 3,
      "levelCode": "M6",
      "group": 6,
      "skill": "tafels",
      "subSkill": "tafels_context",
      "questionType": "multiple_choice",
      "question": "Een groenteboer stapelt appels in een krat. Het krat heeft 4 lagen en in elke laag liggen 8 appels. Hoeveel appels passen er in het krat?",
      "options": ["32", "28", "36", "24"],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Lagen × appels per laag",
            "content": "4 lagen van 8 appels = 4 × 8 = 32. Verdubbel-truc: 2 × 8 = 16, verdubbel → 32.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "tafels_context_lagen",
      "variantIndex": 4,
      "citoDifficulty": 0.30,
      "citoDiscrimination": 0.70,
      "feedback": {
        "explanationText": "4 lagen van 8 appels = 4 × 8 = 32 appels. Verdubbel-truc: 2 × 8 = 16, en 4 is het dubbele van 2, dus 16 × 2 = 32.",
        "solutionSteps": [
          "Lees: 4 lagen, 8 appels per laag",
          "Herken: 4 × 8",
          "Reken uit: 4 × 8 = 32"
        ],
        "distractorExplanations": {
          "0": "Goed! 4 × 8 = 32 appels in het krat.",
          "1": "Je dacht waarschijnlijk aan 4 × 7 = 28. Maar er liggen 8 appels per laag, niet 7. Onthoud: 4 × 8 = 32.",
          "2": "Je dacht waarschijnlijk aan 4 × 9 = 36. Maar er liggen 8 appels per laag, niet 9. Onthoud: 4 × 8 = 32.",
          "3": "Je dacht waarschijnlijk aan 3 × 8 = 24. Maar er zijn 4 lagen, niet 3. Onthoud: 4 × 8 = 32."
        }
      }
    },
    {
      "id": "REK-TAFELS-TOEPASSEN-005",
      "familyId": "REK-TAFELS-TOEPASSEN",
      "module": "Basisrekenen",
      "tier": 3,
      "levelCode": "M6",
      "group": 6,
      "skill": "tafels",
      "subSkill": "tafels_context",
      "questionType": "multiple_choice",
      "question": "Een schooldirecteur bestelt pennen voor de school. Er zijn 7 klassen en elke klas krijgt 6 pakjes pennen. In elk pakje zitten 5 pennen. Hoeveel pennen bestelt de directeur in totaal?",
      "options": ["210", "42", "180", "245"],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Stap voor stap — drie getallen",
            "content": "Stap 1: Hoeveel pakjes? 7 klassen × 6 pakjes = 42 pakjes. Stap 2: Hoeveel pennen? 42 pakjes × 5 pennen = 210 pennen. Truc: 42 × 5 = 42 × 10 ÷ 2 = 420 ÷ 2 = 210.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "tafels_context_driestaps",
      "variantIndex": 5,
      "citoDifficulty": 0.48,
      "citoDiscrimination": 0.78,
      "feedback": {
        "explanationText": "Eerst het aantal pakjes: 7 × 6 = 42 pakjes. Dan het totaal: 42 × 5 = 210 pennen. Handig: 42 × 5 = de helft van 42 × 10 = 420 ÷ 2 = 210.",
        "solutionSteps": [
          "Stap 1: 7 klassen × 6 pakjes = 42 pakjes",
          "Stap 2: 42 pakjes × 5 pennen = ?",
          "Reken: 42 × 5 = 210 pennen"
        ],
        "distractorExplanations": {
          "0": "Goed! 7 × 6 = 42 pakjes, en 42 × 5 = 210 pennen in totaal.",
          "1": "Je berekende alleen 7 × 6 = 42 — dat is het aantal pakjes, niet het aantal pennen. Je moet nog vermenigvuldigen met 5: 42 × 5 = 210.",
          "2": "Je dacht waarschijnlijk aan 6 × 6 × 5 = 180. Maar er zijn 7 klassen, niet 6. 7 × 6 × 5 = 210.",
          "3": "Je dacht waarschijnlijk aan 7 × 7 × 5 = 245. Maar elke klas krijgt 6 pakjes, niet 7. 7 × 6 × 5 = 210."
        }
      }
    }
  ]
}
